import React, { useEffect } from "react";
import { Box, Grid, Typography, Card, CardMedia, CardContent, Link } from "@mui/material";
import Footer from "./Footer";
import useMediaQuery from "@mui/material/useMediaQuery";



const Retail= () => {
    const isMobile = useMediaQuery("(max-width: 900px)");


    useEffect(() => {
            window.scrollTo(0, 0); // Scroll to top when component loads
          },[]);
    
        const caseStudies = [
            {
              title: "An IT foundation to build on",
              company: "KB Home",
              description:
                "KB Home partners with Tech Informatic Solutions to manage IT infrastructure services—covering data center and help desk operations, security, servers, networking and messaging—so staff can focus on the core business.",
              image: "/image/retailcs1.jpg",
              link: "/retailcs1", // updated
            },
            {
              title: "Innovating at the speed of the market",
              company: "Flexport",
              description:
                "With its freight forwarding cloud solutions in high demand — the company doubled in size in three years — Flexport needed to maximize its team resources.",
              image: "/image/retailcs2.jpg",
              link: "/retailcs2", // updated
            },
          ];

return (
    <>
      {/* First Section - Background Image */}
      <Box
  sx={{
    position: "relative",
    width: "100%",
    minHeight: "100vh", // Use minHeight instead of fixed height
    backgroundImage: `url("/image/retailimg.jpg")`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    color: "white",
    overflow: "hidden", // Prevents content from spilling over
  }}
>
  {/* Dark overlay for readability */}
  <Box
    sx={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    }}
  />

  {/* Content Box */}
  <Box
    sx={{
      position: "relative",
      maxWidth: "700px",
      marginLeft: { xs: "3%", md: "8%" },
      marginTop: { xs: "40%", md: "20%" }, // Reduce margin to avoid overflow
      zIndex: 1,
      padding: 4,
      
    }}
  >
    <Typography 
      variant="h3" 
      sx={{ 
        fontWeight: "bold", 
        mb: 2, 
        fontSize: { xs: "42px", md: "60px" }, // Reduce size slightly for better fit
      }}
    >
    Retail & CPG
    </Typography>
    <Typography 
      variant="body1" 
      sx={{ 
        fontSize: { xs: "18px", md: "18px" }, 
        maxWidth: "100%", 
        wordBreak: "break-word", 
        lineHeight: 1.5, 
      }}
    >
   Intelligently informing your business for a true competitive advantage.</Typography>
  </Box>
</Box>



   
{/* 2nd Section  */}

<Box sx={{ background: "linear-gradient(to right, #E0F7FA, #B2EBF2, #80DEEA)",position: "relative", overflow: "hidden" }} >
  {/* Background Half-Moon Shape */}
  <Box
    sx={{
      position: "absolute",
      top: 0,
      right: 0,
      width: isMobile ? "100%" : "70%",
      height: "100%",
      background: "white",
      //backgroundColor:"#B0E0E6",
      borderTopLeftRadius: isMobile ? "100% 40%" : "100% 100%",
      borderBottomLeftRadius: isMobile ? "100% 40%" : "100% 100%",
      zIndex: 0,
    }}
  />

  {/* Actual Content (your original layout) */}
  <Box
    sx={{
      position: "relative",
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      alignItems: "center",
      justifyContent: "center",
      width: isMobile ? "100%" : "90%",
      padding: isMobile ? "30px 15px" : "50px 50px",
      gap: "50px",
      boxSizing: "border-box",
      margin: "0 auto",
      minHeight: isMobile ? "auto" : "100vh",
      paddingTop: isMobile ? "120px" : "0px",
      marginBottom: isMobile ? "100px" : "-50px",
      zIndex: 1,
    }}
  >
    {/* Left Content */}
    <Box
      sx={{
        flex: 1,
        textAlign: isMobile ? "center" : "left",
        margin: "0px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Typography
        variant="h3"
        sx={{
          fontSize: isMobile ? "50px" : "60px",
          marginTop: "-5px",
        }}
        mb={8}
      >
        Delivering competitive advantage from consumer experience through to value chain optimization
      </Typography>

      <Typography variant="body1" sx={{ marginTop: 2, fontSize: "18px", color: "#555" }}>
      Whether it’s rethinking how your products are marketed and serviced to consumers, improving transparency and efficiency in end-to-end enterprise planning, or leveraging AI, data insights and analytics in real time, Tech Informatic Solutions has the skills and expertise needed to help create your strategic advantage. Our industry experts can help you optimize your business across the value chain and anticipate and prepare for changing demands to deliver sustained long-term growth.</Typography>
      <Typography variant="body1" sx={{ marginTop: 2, fontSize: "18px", color: "#555" }}>
      As a trusted partner, we help enable more intelligent, real-time decisions and empower businesses to become more efficient while increasing speed to market.</Typography>


    </Box>

    {/* Right Image */}
    <Box
      sx={{
        flex: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "0px",
        marginTop: isMobile ? "50px" : "0px",
      }}
    >
      <img
        src="/image/retailimg3.jpg"
        alt="About Us"
        style={{
          width: isMobile ? "90%" : "100%",
          maxHeight: "100%",
          objectFit: "cover",
          borderRadius: "10px",
          boxShadow: `
            0px 12px 25px rgba(0, 0, 0, 0.6),  
            inset 0px 10px 20px rgba(255, 255, 255, 0.15),
            inset 0px -10px 30px rgba(0, 0, 0, 0.7),
            inset 10px 0px 20px rgba(0, 0, 0, 0.5), 
            inset -10px 0px 20px rgba(255, 255, 255, 0.2)
          `,
        }}
      />
    </Box>
  </Box>
</Box>





{/* 3rd section */}
<Box sx={{   background: "linear-gradient(to right, #E0F7FA, #B2EBF2, #80DEEA)", width: "100%", padding: "40px 0" }}>
<Box sx={{ px: { xs: 2, md: 10 }, py: 8 }} >
      {/* Title Section */}
      <Typography variant="h3" color="black" fontWeight="bold" gutterBottom  mb={4} mt={8}>
        Case Studies
      </Typography>
      <Typography variant="body1" sx={{  fontSize: "18px", color: "black" }}  mb={10}>
      Read how companies in various industries solved their challenges by partnering with Tech Informatic Solutions.
      </Typography>

      <Grid container spacing={4} >
  {caseStudies.map((item, index) => (
    <Grid item xs={12} md={6} key={index} sx={{ display: "flex" }}>
      <Card
        elevation={0}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          background: "radial-gradient(circle, #1F6788,#161623)",
          color: "white",
          border: "1px solid #eee",
          height: "100%",
          width: "100%",
          minHeight: 550, // ✅ Equal height
          boxShadow: `
            0px 12px 25px rgba(0, 0, 0, 0.6),  
            inset 0px 10px 20px rgba(255, 255, 255, 0.15),
            inset 0px -10px 30px rgba(0, 0, 0, 0.7),
            inset 10px 0px 20px rgba(0, 0, 0, 0.5), 
            inset -10px 0px 20px rgba(255, 255, 255, 0.2)
          `,
        }}
      >
        <CardMedia
          component="img"
          height="350"
          image={item.image}
          alt={item.title}
        />

        <CardContent
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Box>
            <Typography
              variant="caption"
              sx={{ color: "#1976d2", fontWeight: "bold" }}
            >
              {item.company}
            </Typography>

            <Typography
              variant="h6"
              color="white"
              fontWeight="bold"
              mt={1}
            >
              {item.title}
            </Typography>

            <Typography
              variant="body2"
              mt={1}
              color="white"
              sx={{ flexGrow: 1 }}
            >
              {item.description}
            </Typography>
          </Box>

          <Link
            href={item.link}
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            sx={{ mt: 2, fontWeight: "bold", color: "#90caf9" }}
          >
            Read the case study ↗
          </Link>
        </CardContent>
      </Card>
    </Grid>
  ))}
</Grid>

    </Box>
    </Box>




   
<Footer/>
    </>
  );
};
export default Retail;